import React from "react";
import LcLayout from "./src/components/learningCenter/lcLayout";
import FadeInOnFontLoad from "./src/components/shared/fadeInOnFontLoad";
import { ReferralModalTSB } from "./src/components/shared/referralModal";
import PreviewBanner from "./src/components/previewBanner/previewBanner";

// wrapRootElement should not contain UI elements - only providers/contexts
export const wrapRootElement = ({ element }) => element;

export const wrapPageElement = ({ element, props }) => {
  const path = props?.location?.pathname;
  const usesLcLayout = path && (path.startsWith("/learn/") || path === "/updates/");
  const Layout = usesLcLayout ? LcLayout : React.Fragment;

  return (
    <FadeInOnFontLoad>
      <Layout {...(usesLcLayout ? props : {})}>
        <ReferralModalTSB />
        {element}
      </Layout>
      <PreviewBanner location={props?.location} />
    </FadeInOnFontLoad>
  );
};
